import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAdvertisementState, IAdvertisingConfigRaw } from 'redux-state/advertisement/types.js';

/** We remove bannerConfig, skin and interstitial as these are not used within redux */
export const adReducerInitialState: IAdvertisementState = {
  targeting: [],
  queryParams: [],
  // mapTakeover: {
  //   targeting: [],
  //   queryParams: [],
  //   layout: {},
  //   fuseTag: '',
  //   adUnitPath: '',
  //   origin: '',
  // },
};

export const adSlice = createSlice({
  name: 'advertisement',
  initialState: adReducerInitialState,
  reducers: {
    REDUX_AD_UPDATE_CONFIG: (_, action: PayloadAction<IAdvertisingConfigRaw>) => {
      const { targeting, mapTakeover } = action.payload;
      return {
        targeting: targeting?.staticData,
        queryParams: targeting?.queryParams,
        mapTakeover,
      };
    },
    REDUX_AD_CLEAR_CONFIG: () => {
      return { ...adReducerInitialState };
    },
  },
});

export const { REDUX_AD_UPDATE_CONFIG, REDUX_AD_CLEAR_CONFIG } = adSlice.actions;

export const adReducer = adSlice.reducer;
